/**
 * created by hezq on 2019-09-09
 *
 * description： 通用模块接口地址配置
 *
 */

const config = require('libs/config.js')

const common = {
	// 定时刷新token接口地址【post】
	refreshToken: config.API_MB + '/login/refresh/token',
	// 根据userid获取登录用户信息
	getUserInfo: config.MS_XY_PATH + '/outline/web2/basic/user/info',
	// 退出登录【post】
	doLoginOut: config.API_MB + '/login/dologout',
	// 权限组
	getAuthGroup: (groupType) => `${config.MS_AUTH_PATH}/v1/qx/group/hy/group/type/${groupType}`,
	// 获取登录用户的权限
	getQxs: (ssid) => `${config.MS_AUTH_PATH}/v1/qxusifMg/auth/menuByGid/${ssid}/1`,
	// 基础获取框架协议角色
	getBsRole: config.MS_XY_PATH + '/outline/web2/basic/jsxz',

	// 模板列表查询接口
	getTemplateList: config.MS_XY_PATH + '/outline/template',
	// 模板属性查询接口
	getTemplateAttribute: (pkid, isNew) => config.MS_XY_PATH + `/outline/template/get/${pkid}/${isNew ? 1 : 0}`,
	// 产品明细模板导出
	exportTemplate: pkid => config.MS_XY_PATH + `/outline/template/export/${pkid}`,
	// 产品明细导入
	importGoods: pkid => config.MS_XY_PATH + `/outline/template/importGoods?pkid=${pkid}`,
	// 枚举查询
	getEnum: config.MS_XY_PATH + '/basic/enum/',
	// 枚举多个查询
	getMulEnum: config.MS_XY_PATH + '/basic/enum/more'
}

export default common



// WEBPACK FOOTER //
// ./src/api/common.js